var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiSqueezedDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.689,
    height: 147,
    viewBox: "0 0 57.689 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-sqdiam"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 57.689,
    height: 147,
    fill: "none",
    stroke: "#b9b1b4",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crane2",
    transform: "translate(-66.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(66.384)",
    clipPath: "url(#clip-path-sqdiam)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M.5,77.878,17.336.5,26.723,61,24.8,63.047,36.994,146.14ZM17.336.5,8.3,51.466l27.125,83.993L24.8,63.047,26.723,61ZM.5,77.878,13.343,67.216M8.3,51.466,24.8,63.047M12.956,66l12.118-.755",
    transform: "translate(0.18 0.18)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M52.368,69.137,12.876.5,22.263,61l2.453,1.369,13.562,82.882ZM12.876.5,36.929,46.332l-.4,88.264L24.715,62.367,22.263,61ZM52.368,69.137,36.9,62.869m.033-16.537L24.715,62.367M36.9,61.6,25.122,64.549",
    transform: "translate(4.64 0.18)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiSqueezedDiamond);
export default __webpack_public_path__ + "static/media/origami-squeezed-diamond.b2390b039b4cd017c7dbdf242eeac2ba.svg";
export { ForwardRef as ReactComponent };